import Head from 'next/head';
import { useRouter } from 'next/router';

const HreflangTags: React.FC = () => {
  const { locales, defaultLocale, asPath } = useRouter();
  const baseUrl = process.env.NEXT_PUBLIC_APP_BASE_URL || 'https://seeksophie.com';
  const cleanPath = asPath.split('?')[0].split('#')[0].replace(/\/$/, '') || '/';

  return (
    <Head>
      {(locales || []).filter(locale => locale !== 'en').map((locale) => {
        const trueLocale = locale === defaultLocale ? 'en' : locale
        const href = `${baseUrl}${trueLocale === 'en' ? '' : `/${trueLocale}`}${cleanPath === '/' ? '' : cleanPath}`
        return <link key={trueLocale} rel="alternate" href={href} hrefLang={trueLocale} />;
      })}
      <link
        rel="alternate"
        href={`${baseUrl}${cleanPath === '/' ? '' : cleanPath}`}
        hrefLang="x-default"
      />
    </Head>
  );
};

export default HreflangTags;
